
import React from 'react';
import { X, User, Hash, ShoppingCart, DollarSign, Shield } from 'lucide-react';

const ProposalDetailModal = ({ proposal, onClose }) => {
    if (!proposal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl w-full max-w-md relative animate-slide-up flex flex-col" style={{maxHeight: '90vh'}} onClick={(e) => e.stopPropagation()}>
                <header className="p-4 border-b flex justify-between items-center">
                    <h2 className="text-xl font-bold text-gray-800">Detalhes do Orçamento</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200">
                        <X className="w-6 h-6 text-gray-600"/>
                    </button>
                </header>

                <main className="p-4 md:p-6 flex-grow overflow-y-auto space-y-4">
                    <div className="bg-gray-50 p-3 rounded-lg border space-y-2">
                        <div className="flex items-center text-sm text-gray-600">
                            <Shield className="w-4 h-4 mr-2 text-blue-600" />
                            <span>Prestador: <strong>{proposal.serviDetails?.companyName || proposal.serviDetails?.name || 'Não informado'}</strong></span>
                        </div>
                         <div className="flex items-center text-sm text-gray-600">
                            <User className="w-4 h-4 mr-2 text-green-600" />
                            <span>Cliente: <strong>{proposal.clientDetails?.name || 'Não informado'}</strong></span>
                        </div>
                        <div className="flex items-center text-sm text-gray-600">
                            <Hash className="w-4 h-4 mr-2" />
                            <span>ID da Proposta: <strong>{proposal.id.substring(0, 8)}...</strong></span>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-bold mb-2 text-gray-700 flex items-center"><ShoppingCart className="w-5 h-5 mr-2 text-blue-600"/> Itens da Proposta</h3>
                        <ul className="divide-y divide-gray-200 border rounded-lg overflow-hidden">
                            {proposal.items.map((item, index) => (
                                <li key={index} className="flex justify-between items-center p-3 bg-white">
                                    <span className="text-gray-800">{item.description}</span>
                                    <span className="font-semibold text-gray-900">R$ {parseFloat(item.price).toFixed(2)}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </main>

                <footer className="p-4 bg-gray-100 border-t space-y-2">
                    <div className="flex justify-between items-center text-lg font-bold text-gray-800">
                        <span className='flex items-center'><DollarSign className="w-5 h-5 mr-1.5"/> TOTAL</span>
                        <span>R$ {proposal.total.toFixed(2)}</span>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default ProposalDetailModal;
